import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {displayLocalValidationError} from "../../helpers/forms/validationErrors/utils";

function initPublicAuditionChooseConflictsIndex() {

	// Setup submit button
	const submitButton = document.querySelector('.continue-button')
	submitButton.addEventListener('click', handleContinueRequest)

	// Setup conflict buttons
	document.querySelectorAll('.conflict-date').forEach(container => {
		// Setup checkbox
		const checkbox = container.querySelector('input[type="checkbox"]');

		checkbox.addEventListener('change', () => handleConflictToggle(container, checkbox))

		// Initial render
		handleConflictToggle(container, checkbox, false)
	})

	// Setup no conflicts checkbox
	const noConflictsCheckbox = document.querySelector('.no-conflicts-checkbox');
	noConflictsCheckbox.addEventListener('change', clearAllConflicts)

	// Allow the user to continue if they have viewed the last conflicts
	const observer = new IntersectionObserver(
		handleConflictsIntersection,
		{
			root: document.querySelector('.audition-request-conflicts-card .card-body'),
			threshold: 0.8,
		}
	)

	// Retrieve last conflict
	const conflictDatesContainers = Array.from(document.querySelectorAll('.conflict-date'));

	// Obsert last conflict
	observer.observe(conflictDatesContainers[conflictDatesContainers.length - 1]);

	// Check if user already checked all conflicts, so we can
	// let them continue without scrolling all the way down again
	const requestId = document.querySelector('input[name="request_id"]').value;

	try {
		const allReviewedFlag = localStorage.getItem(`request-${requestId}-all-conflicts-reviewed`);

		if (allReviewedFlag) {
			enableSubmission();
		}
	} catch (e) {
		console.log('Error retrieving local storage')
		console.log(e)
	}

	/** Methods */

	function handleContinueRequest() {
		if (submitButton.classList.contains('disabled')) {
			displayLocalValidationError(document.body, '', 'Please review all possible conflicts to continue')
			return;
		}

		loading();

		// Retrieve conflict dates
		const rehearsalConflicts = [];
		const showConflicts = [];

		document.querySelectorAll('.rehearsal-conflict-checkbox:checked').forEach(checkbox => {
			// Retrieve reason from related input
			const reason = checkbox.closest('.conflict-date').querySelector('.conflict-cause-input').value;

			rehearsalConflicts.push({
				// Save rehearsal id from checkbox
				rehearsal_id: checkbox.value,
				reason,
			})
		});

		document.querySelectorAll('.show-conflict-checkbox:checked').forEach(checkbox => {
			// Retrieve reason from related input
			const reason = checkbox.closest('.conflict-date').querySelector('.conflict-cause-input').value;

			showConflicts.push({
				// Save rehearsal id from checkbox
				show_id: checkbox.value,
				reason,
			})
		});

		const data = {
			rehearsalConflicts,
			showConflicts
		};

		Axios.post(submitButton.dataset.route, data)
			.then(response => {
				setTimeout(() => {
					// Show loading again
					loading();

					// Redirect to next step
					// noinspection JSUnresolvedReference
					window.location.href = response.data.redirectUrl;
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)

	}

	/**
	 * @param {HTMLElement} conflictContainer
	 * @param {HTMLInputElement}checkbox
	 * @param focusInput
	 */
	function handleConflictToggle(conflictContainer, checkbox, focusInput = true) {
		conflictContainer.classList.toggle('active', checkbox.checked);

		if (checkbox.checked && focusInput) {
			// Focus input
			conflictContainer.querySelector('.conflict-cause-input').focus();

			// Also clear no conflicts checkbox as is a vile lie
			noConflictsCheckbox.checked = false;
		}
	}

	function clearAllConflicts() {
		document.querySelectorAll('.conflict-date').forEach(container => {
			// Setup checkbox
			const checkbox = container.querySelector('input[type="checkbox"]');

			checkbox.checked = false;

			// Clear input
			handleConflictToggle(container, checkbox, false)
		})
	}

	/**
	 * @param {IntersectionObserverEntry[]} entries
	 */
	function handleConflictsIntersection(entries) {
		// There should be only one entry, the last conflict
		const conflictContainer = entries[0];

		// Check if it reached the intersecting threshold
		if (conflictContainer && conflictContainer.isIntersecting) {
			enableSubmission();
		}
	}


	function enableSubmission() {
		// Save local state to allow submission on reloads
		// or when coming back
		try {
			localStorage.setItem(`request-${requestId}-all-conflicts-reviewed`, '1')
		} catch (e) {
			console.log('Error saving to local storage')
			console.log(e);
		}

		submitButton.classList.remove('disabled');
		submitButton.title = '';
	}
}

export {
	initPublicAuditionChooseConflictsIndex
}
